<template>
  <div>
    <Header />
    <b-container class="my-4">
      <h1>Ligas</h1>
      <div class="clearfix">
        <b-img
          width="140"
          class="ml-3 float-right"
          src="../assets/corpo.jpg"
          rounded="circle"
          fluid
          alt="Ligas"
        />
        <p class="lead">
          Organizamos ligas masculinas, femeninas de basketball y en volleyball mixto.
          <br>Participa con tus amigos, o con el equipo de tú empresa.
        </p>
      </div>
      <hr />
      <Jumbo
        label="¿Te gustaria participar con tus amigos, o con el equipo de tú empresa?"
        btn="Saber más de las ligas"
      />
    </b-container>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/home/Header.vue'
import Jumbo from '@/components/home/Jumbo.vue'
import Footer from '@/components/home/Footer.vue'
export default {
  components: {
    Header,
    Jumbo,
    Footer
  }
}
</script>
